import { FC } from 'react';
import { Typography } from '@material-ui/core';
import { Test } from '../types';
import { useTestResults } from './hooks/useTestResult';

interface Props {
  test: Test;
}

const TestResultsLabel: FC<{
  count: number;
  singleLabel: string;
  multiLabel: string;
  message: string;
}> = ({ count, singleLabel, multiLabel, message }) => {
  const label = `${count} ${count > 1 ? multiLabel : singleLabel} ${message}`;

  return Boolean(count) ? <Typography>{label}</Typography> : <></>;
};

export const TestResults: FC<Props> = ({ test }) => {
  const {
    success,
    policiesFailed,
    policiesWithWarnings,
    metricsFailed,
    componentsFailed,
  } = useTestResults(test);

  return (
    <>
      {success && <Typography>Success</Typography>}
      <TestResultsLabel
        count={policiesFailed}
        singleLabel="policy"
        multiLabel="policies"
        message="check failed"
      />

      <TestResultsLabel
        count={metricsFailed}
        singleLabel="metric"
        multiLabel="metrics"
        message="check failed"
      />

      <TestResultsLabel
        count={policiesWithWarnings}
        singleLabel="policy"
        multiLabel="policies"
        message="check with warnings"
      />

      <TestResultsLabel
        count={componentsFailed}
        singleLabel="component"
        multiLabel="components"
        message="check failed"
      />
    </>
  );
};
